import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'limitNamePipe', standalone: true })
export class limitNamePipe implements PipeTransform {
    transform(limit: string) {
        const limitName = limit.split('_').join(' ').toLowerCase();
        return `${limitName.charAt(0).toUpperCase()}${limitName.substr(1)}`;
    }
}
